import { jwtDecode } from 'jwt-decode';
import { useEffect, useState } from 'react';

import { agent } from 'api/agent';
import refreshTokenMutation from 'api/mutations/refreshTokenMutation';
import SecureStorage from 'utils/localStorage';

const useToken = () => {
  const [loading, setLoading] = useState(true);
  const { mutate } = refreshTokenMutation();

  useEffect(() => {
    const token = SecureStorage.getItemSync('token');
    const refreshToken = SecureStorage.getItemSync('refreshToken');

    if (token && refreshToken && token !== 'undefined') {
      const decodedToken = jwtDecode(token);
      const now = new Date();

      if (decodedToken.exp) {
        const expired = new Date(decodedToken.exp * 1000);
        expired.setHours(expired.getHours() - 2);

        if (now >= expired) {
          mutate(refreshToken, {
            onSuccess(res) {
              SecureStorage.setItem('token', res.data.token, { secure: true });
              SecureStorage.setItem('refreshToken', res.data.refreshToken, { secure: true });
              agent.getClient(false).defaults.headers.common[
                'Authorization'
              ] = `Bearer ${res.data.token}`;
              setLoading(false);
            },
            onError() {
              setLoading(false);
              SecureStorage.clear();
            },
          });
        } else {
          setLoading(false);
        }
      } else {
        setLoading(false);
      }
    } else {
      SecureStorage.clear();
      setLoading(false);
    }
  }, []);

  return { loading };
};

export default useToken;
